import { getSettingsEditing } from 'client/reducers/managementReducer'
import { useManagement } from 'client/store'
import React, { useLayoutEffect, useState } from 'react'
import { Switcher } from 'src/editor/shared/ui-lib/switcher'
import { FormInterface } from 'src/shared/types/entities/form-interface'
import { FormActionSettings } from './form-action-settings'
import { FormDesignSettings } from './form-design-settings'
import { FormSubEntitiesSettings } from './form-sub-entities-settings'

export interface FormSettingsProps {
  entity: FormInterface
  defaultEntity?: FormInterface
}

enum SubSettingsEnum {
  Fields = 'fields',
  Design = 'design',
  Action = 'action',
}

export const FormSettings = ({ entity, defaultEntity }: FormSettingsProps) => {
  const editingFormCommonSettingsType =
    useManagement(getSettingsEditing).commonSettingsType

  const [subSettings, setSubSettings] = useState<SubSettingsEnum>(
    SubSettingsEnum.Fields,
  )

  useLayoutEffect(() => {
    if (editingFormCommonSettingsType) {
      setSubSettings(SubSettingsEnum.Design)
    }
  }, [editingFormCommonSettingsType])

  return (
    <>
      <Switcher
        btnList={[
          {
            value: SubSettingsEnum.Fields,
            content: 'components.core.toolbox.types.elements',
          },
          {
            value: SubSettingsEnum.Design,
            content: 'components.core.toolbox.types.design',
          },
          {
            value: SubSettingsEnum.Action,
            content: 'components.core.toolbox.types.action',
          },
        ]}
        value={subSettings}
        update={setSubSettings}
        wrapperClassName="p-0 mb-5"
      />

      {subSettings === SubSettingsEnum.Fields ? (
        <FormSubEntitiesSettings entity={entity} />
      ) : subSettings === SubSettingsEnum.Design ? (
        <FormDesignSettings entity={entity} defaultEntity={defaultEntity} />
      ) : (
        <FormActionSettings entity={entity} />
      )}
    </>
  )
}
